module.exports = __webpack_public_path__ + "img/phoneCode.9c73421a.png";